import React from 'react';
import { motion } from 'framer-motion';
import useReveal from '../../utils/useReveal';
import styled from 'styled-components';
import { FaServer, FaLaptopCode, FaDatabase, FaRobot, FaTools, FaCodeBranch } from 'react-icons/fa';
import { sectionTitle } from '../../styles/sectionStyles';
import { skills } from '../../data/constants';

const Container = styled.section`
  padding: 88px 20px;
  background: var(--background);
  @media (max-width: 640px) { padding: 64px 16px; }
`;
const Wrapper = styled.div`max-width: 1180px; margin: 0 auto;`;
const Header = styled.div`
  max-width: 740px; margin: 0 0 36px; text-align: left;
  span { color: var(--accent); font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.16em; }
  h2 { ${sectionTitle} margin: 12px 0; }
  p { color: var(--muted); font-size: 17px; line-height: 1.65; }
`;
const Grid = styled.div`
  display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px;
  @media (max-width: 980px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 620px) { grid-template-columns: 1fr; }
`;
const Panel = styled.article`
  padding: 26px; border-radius: 20px; border: 1px solid var(--border); background: var(--surface);
  h3 { display: flex; align-items: center; gap: 12px; font-size: 17px; margin-bottom: 22px; color: var(--text); }
  h3 svg { color: var(--accent); flex-shrink: 0; }
`;
const List = styled.ul`list-style: none; display: flex; flex-wrap: wrap; gap: 10px;`;
const Skill = styled.li`
  display: inline-flex; align-items: center; gap: 9px; padding: 9px 11px;
  border: 1px solid var(--border); border-radius: 10px; background: var(--surface-soft);
  color: var(--text); font-size: 13px; font-weight: 600;
  img { width: 20px; height: 20px; object-fit: contain; }
`;
const icons = [FaServer, FaLaptopCode, FaDatabase, FaRobot, FaTools, FaCodeBranch];
export default function Skills() {
  const reveal = useReveal();
  return <Container id="skills"><Wrapper>
    <Header as={motion.div} {...reveal}><span>My Toolkit</span><h2>Skills & Technologies</h2><p>I use these technologies to develop APIs, build full-stack applications, work with data, and integrate AI services.</p></Header>
    <Grid>{skills.map((group, index) => { const Icon = icons[index]; return <Panel as={motion.article} {...reveal} transition={{ ...reveal.transition, delay: reveal.transition.duration ? (index % 3) * 0.06 : 0 }} key={group.title}><h3><Icon aria-hidden="true" />{group.title}</h3><List>{group.skills.map(skill => <Skill key={skill.name}><img src={skill.image} alt="" width={20} height={20} loading="lazy" decoding="async" onError={event => { event.currentTarget.style.display = 'none'; }} /><span>{skill.name}</span></Skill>)}</List></Panel>; })}</Grid>
  </Wrapper></Container>;
}
